import { useMutation } from "@tanstack/react-query";

import { httpClient } from "@/lib/http";
import { HttpResponse, SetPasswordRequest, SetPasswordResponse } from "@/types";

export const useSetPassword = () => {
  return useMutation({
    mutationFn: async ({
      setPasswordRequest,
    }: {
      setPasswordRequest: SetPasswordRequest;
    }) => {
      const res = await httpClient.post<
        SetPasswordResponse,
        HttpResponse<SetPasswordResponse>,
        SetPasswordRequest
      >("join/set-password", setPasswordRequest, {
        // So that the cookie is stored from the response.
        withCredentials: true,
      });

      return res.data;
    },
  });
};
